import { format, formatISO, parse, parseISO } from 'date-fns';

export interface ISchool {
  schoolName: string;
  schoolPhoneNumber: string;
  addressLine1: string;
  addressLine2: string | null;
  addressLine3: string | null;
  townCity: string;
  county: string;
  country: string;
  postcodeZipcode: string;
  yearlyArchivingDate?: string;
  financeEmail?: string;
  Logo?: string;
  bDeleteLogo?: boolean;
  logoUrl?: string;
  logoExtension?: string;
}

export interface IArchivingInfo {
  password: string;
  yearlyArchivingDate?: string;
}

export class SchoolParser {
  public static createEmptyArchivingInfo = (): IArchivingInfo => ({
    password: '',
    yearlyArchivingDate: '',
  });

  public static parseGetSchoolDetails = (response: any): ISchool => ({
    ...response,
    addressLine2: response.addressLine2 ?? '',
    addressLine3: response.addressLine3 ?? '',
    county: response.county ?? '',
    yearlyArchivingDate: format(
      parseISO(response.yearlyArchivingDate),
      'dd/MM/yyyy'
    ),
  });

  public static buildSubmitSchoolPayload = (values: ISchool) => ({
    schoolName: values.schoolName,
    schoolPhoneNumber: values.schoolPhoneNumber,
    addressLine1: values.addressLine1,
    addressLine2: values.addressLine2,
    addressLine3: values.addressLine3,
    townCity: values.townCity,
    county: values.county,
    postcodeZipcode: values.postcodeZipcode,
    country: values.country,
    FinanceEmail: values.financeEmail,
  });

  public static buildArchiveSchoolPayload = (values: IArchivingInfo) => {
    if (!values.yearlyArchivingDate) return;

    return {
      password: values.password,
      yearlyArchivingDate: formatISO(
        parse(values.yearlyArchivingDate, 'dd/MM/yyyy', new Date())
      ),
    };
  };

  public static buildArchiveNowPayload = (
    values: IArchivingInfo
  ): IArchivingInfo => ({
    password: values.password,
  });

  public static parseError = (errors: any) => {
    let error: string;
    switch (errors[0].messageCode) {
      case 'School_Acccount_Recently_Archived':
        error = 'School account recently archived';
        break;
      case 'Invalid_ArchivingDate':
        error = 'Invalid archiving date ';
        break;
      case 'Incorrect_Password':
        error = 'Invalid password';
        break;
      default:
        error = 'Sorry something went wrong. Please try again.';
    }
    return error;
  };
}
